import React, { useContext } from 'react';
import { ModalContext } from 'app/app';
import { FileText } from 'feather-icons-react';
import styles from './styles.module.scss';

export function TemplateButton({ toolType, onTemplateSelect, className = "", variant = "default", keepParentOpen = false, parentModal = null, parentData = null }) {
  const { setModal } = useContext(ModalContext);

  const handleClick = () => {
    setModal({
      name: 'message_templates_modal',
      data: {
        toolType,
        onTemplateSelect,
        keepParentOpen,
        parentModal,
        parentData
      }
    });
  };

  if (variant === "icon") {
    return (
      <button
        type="button"
        className={`${styles.templateIconButton} ${className}`}
        onClick={handleClick}
        title="Use message template"
      >
        <FileText size={18} />
      </button>
    );
  }

  return (
    <button
      type="button"
      className={`${styles.templateButton} ${className}`}
      onClick={handleClick}
      title="Use message template"
    >
      <FileText size={16} />
      Templates
    </button>
  );
} 